var $ = jQuery.noConflict()

$(document).ready(function() {

	Reveals.init();
	Menu.init();	
	FullHeight.init();

	if(Config.debug_mode == true){
		Debug.init();	
	}

	var template = $('#content').attr('data-template');
	
	switch(template){
		case "homepage":

			break;
		default:

			break;
								 }


});